import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

const JANELA_TOAST_IDENTICO_MS = 1000;
const JANELA_SUPRIMIR_UI_APOS_HTTP_MS = 1000;

type Severidade = 'error' | 'success' | 'warn' | 'info';

@Injectable({
  providedIn: 'root',
})
export class NotificacaoService {
  private ultimoToastHttpEm = 0;
  private ultimoIdenticoEm = new Map<string, number>();

  constructor(private messageService: MessageService) {}

  notificacaoError(mensagem: string, time = 7000) {
    this.exibir('error', 'Erro', mensagem, time);
  }

  notificacaoSuccess(mensagem: string, time = 3500) {
    this.exibir('success', 'Sucesso', mensagem, time);
  }

  notificacaoWarn(mensagem: string, time = 5000) {
    this.exibir('warn', 'Aviso', mensagem, time);
  }

  notificacaoInfo(mensagem: string, time = 4000) {
    this.exibir('info', 'Informação', mensagem, time);
  }

  notificacaoWarnPersistente(mensagem: string) {
    this.exibir('warn', 'Configuração Pendente', mensagem, undefined, true);
  }

  notificacaoHttpError(mensagem: string, time = 7000) {
    this.exibir('error', 'Erro', mensagem, time, false, true);
  }

  notificacaoHttpSuccess(mensagem: string, time = 3500) {
    this.exibir('success', 'Sucesso', mensagem, time, false, true);
  }

  notificacaoHttpWarn(mensagem: string, time = 8000) {
    this.exibir('warn', 'Aviso', mensagem, time, false, true);
  }

  private exibir(
    severity: Severidade,
    summary: string,
    detail: string,
    life?: number,
    sticky = false,
    origemHttp = false
  ) {
    const agora = Date.now();
    const chave = `${severity}|${detail}`;
    const identicoEm = this.ultimoIdenticoEm.get(chave);

    if (identicoEm && agora - identicoEm < JANELA_TOAST_IDENTICO_MS) {
      return;
    }

    if (
      !origemHttp &&
      agora - this.ultimoToastHttpEm < JANELA_SUPRIMIR_UI_APOS_HTTP_MS
    ) {
      return;
    }

    this.ultimoIdenticoEm.set(chave, agora);
    if (origemHttp) {
      this.ultimoToastHttpEm = agora;
    }

    this.messageService.add({
      severity,
      summary,
      detail,
      ...(sticky ? { sticky: true } : { life }),
    });
  }
}
